import { loadImportPreview, resumeQueuedImport, watchQueuedImport } from './importpreview';
import { ajaxPromise, confirmDialog, displayNotification, logerror, toggleSlide } from './utils';

if ($('#vendor_import_form').length === 1) {
    init_vendor_import();
}

function init_vendor_import() {
    let uploadResponse: any = null;
    let guid: string | null = null;
    let previewTable: DataTables.Api | null = null;

    toggleSlide($('#vendor_import_options_toggle'), $('#vendor_import_options_container'));

    $('#vendor_import_cancel').off('click').on('click', () => {
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        window.location.href = '/ui';
    });

    $('#vendor_import_options_reset').on('click', () => {
        $('#vendor_import_auto_create_related').val('1');
    });

    $('#vendor_import_download_template').on('click', () => {
        window.location.href = '/data/vendors_template';
    });

    const showUploadForm = () => {
        $('#vendor_import_upload_section').show();
        $('#vendor_import_preview_section').hide();
        $('#vendor_import_commit_status').hide();
        $('#vendor_import_commit, #vendor_import_discard').prop('disabled', false);
    };

    const showPreview = () => {
        $('#vendor_import_upload_section').hide();
        $('#vendor_import_preview_section').show();
    };

    $('#vendor_import_test').on('click', async function () {
        const fileInput = $('#vendor_import_file')[0] as HTMLInputElement;
        if (!fileInput.files || !fileInput.files.length) {
            displayNotification('No File', 'Please select a file first.', 'warning');
            return;
        }

        const formData = new FormData();
        formData.append('file', fileInput.files[0]);
        formData.append('mode', '0');
        formData.append('auto_create_related', $('#vendor_import_auto_create_related').val() as string);

        $('#vendor_import_spinner').show();
        $('#vendor_import_test').prop('disabled', true);

        try {
            const response = await ajaxPromise('/import/vendor_upload', formData);
            $('#vendor_import_spinner').hide();
            $('#vendor_import_test').prop('disabled', false);

            if (response.msgs) {
                uploadResponse = response;
                previewTable = loadImportPreview({
                    prefix: 'vendor_import',
                    uploadResponse: response,
                    existingTable: previewTable,
                    showPreview,
                });
                displayNotification('Upload Failed', 'The spreadsheet format is invalid. Please check the errors.', 'danger');
                return;
            }

            if (response.rc === 'OK') {
                guid = response.guid;
                uploadResponse = response;
                previewTable = loadImportPreview({
                    prefix: 'vendor_import',
                    uploadResponse: response,
                    existingTable: previewTable,
                    showPreview,
                });
                displayNotification('Upload Successful', 'Please review the changes before confirming.', 'success');
            } else {
                displayNotification('Upload Failed', response.message || response.msg || 'The import test failed. Please check your file.', 'danger');
            }
        } catch (error) {
            $('#vendor_import_spinner').hide();
            $('#vendor_import_test').prop('disabled', false);
            displayNotification('Error', 'An error occurred while processing the file.', 'danger');
            logerror('vendor import test', error);
        }
    });

    $('#vendor_import_commit').on('click', async function () {
        if (!guid) {
            displayNotification('Preview Required', 'Please run a preview first.', 'warning');
            return;
        }

        const { preview } = uploadResponse || {};
        const hasErrors = preview && preview.some((row: any) => row.errors && row.errors.length > 0);
        if (hasErrors) {
            displayNotification('Errors Present', 'Cannot confirm import with validation errors. Please fix your spreadsheet and re-upload.', 'danger');
            return;
        }

        const confirmed = await confirmDialog({
            dialogTitle: 'Confirm Import',
            bodyText: 'Are you sure you want to confirm this import? This action cannot be undone.',
            confirmText: 'Confirm Import',
            confirmStyle: 'success',
        });

        if (!confirmed) {
            return;
        }

        const formData = new FormData();
        formData.append('guid', guid);
        formData.append('mode', '1');
        formData.append('auto_create_related', $('#vendor_import_auto_create_related').val() as string);

        $('#vendor_import_commit, #vendor_import_discard').prop('disabled', true);

        try {
            const response = await ajaxPromise('/import/vendor_upload', formData);
            if (!response.queued) {
                $('#vendor_import_commit, #vendor_import_discard').prop('disabled', false);
                displayNotification('Import Failed', response.message || response.msg || 'The import failed.', 'danger');
                return;
            }

            $('#vendor_import_commit_status_text').text('Import queued. You can leave this page. Coming back will show whether it is still running.');
            $('#vendor_import_commit_status').show();

            const result = await watchQueuedImport(guid);
            if (result.state === 'done') {
                displayNotification('Import Complete', 'Vendors have been successfully imported.', 'success');
                const formElement = $('#vendor_import_form')[0] as HTMLFormElement;
                formElement.reset();
                uploadResponse = null;
                guid = null;
                $('.file-text').text('Choose a file or drag it here');
                showUploadForm();
            } else if (result.state === 'waiting') {
                $('#vendor_import_commit_status i').removeClass('fa-spin fa-spinner').addClass('fa-clock-o');
                $('#vendor_import_commit_status_text').text(result.msg);
                displayNotification('Import Still Running', result.msg, 'info');
            } else {
                $('#vendor_import_commit_status').hide();
                $('#vendor_import_discard').prop('disabled', false);
                displayNotification('Import Failed', result.msg, 'danger');
            }
        } catch (error) {
            $('#vendor_import_commit_status').hide();
            $('#vendor_import_commit, #vendor_import_discard').prop('disabled', false);
            displayNotification('Error', 'An error occurred while committing the import.', 'danger');
            logerror('vendor import commit', error);
        }
    });

    $('#vendor_import_discard').on('click', async function () {
        const confirmed = await confirmDialog({
            dialogTitle: 'Discard Changes',
            bodyText: 'Are you sure you want to discard these changes?',
            confirmText: 'Discard',
            confirmStyle: 'warning',
        });

        if (confirmed) {
            if (guid) {
                try {
                    const response = await ajaxPromise('/import/discard', { guid });
                    if (response.rc !== 'OK') {
                        displayNotification('Discard Failed', response.msg || response.message || 'This preview could not be discarded.', 'danger');
                        return;
                    }
                } catch (error) {
                    logerror('vendor import discard', error);
                    displayNotification('Discard Failed', 'This preview could not be discarded.', 'danger');
                    return;
                }
            }

            const formElement = $('#vendor_import_form')[0] as HTMLFormElement;
            formElement.reset();
            uploadResponse = null;
            guid = null;
            $('.file-text').text('Choose a file or drag it here');
            showUploadForm();
        }
    });

    $('#vendor_import_file').on('change', function () {
        uploadResponse = null;
        const fileInput = this as HTMLInputElement;
        const fileLabel = $('.file-text');
        if (fileInput.files && fileInput.files.length > 0) {
            fileLabel.text(fileInput.files[0].name);
        } else {
            fileLabel.text('Choose a file or drag it here');
        }
    });

    resumeQueuedImport('vendor_import', 'vendor', 'Vendors have been successfully imported.');
}
